"use client";

import {
  BlockHeaderSuperposition,
} from "@/components/templates";
import { MyH2 } from "@/components/atoms";
import heroImage from "../../../assets/images/garden.jpg";
import group from "../../../assets/images/groupe.jpg";
import work from "../../../assets/images/work.jpg";
import styles from "./styles.module.scss";
import bgBeige from "../../../assets/images/bg_beige.jpg";
import Image from "next/image";
import { MyButton } from "@/components/atoms";
import { nosValeurs, teamMembers } from "./data";
import uniqid from "uniqid";
import { useRouter } from "next/navigation";
import classNames from "classnames";
import { TitleIcon } from "@/components/molecules/titleIcon";



const Apropos = () => {
  const router = useRouter();

  return (
    <>
      <BlockHeaderSuperposition
        title="Notre vision de l’entreprise"
        image={heroImage}
        textInWhiteBlock="<p>À taille humaine. Respect, conscience professionnelle, écoute, savoir-faire, développement personnel et professionnel.</p><p>Ça vous parle ? À nous aussi !</p>"
        breadCrumbProps={{
          data: [
            {
              url: "/",
              label: "Accueil",
            },
            {
              url: "/a-propos",
              label: "À propos",
            },
          ],
        }}
        btnlabel="Contactez-nous !"
        onClickBtn={() => router.push("/contact")}
      />
      <div className={styles.second_block}>
        <div className={styles.first_row}>
          <div className={styles.contents}>
            <h2>Notre façon de construire nous définit.</h2>
            <Image
              src={group}
              alt="Notre façon de construire nous définit."
              className={styles.img}
            />
            <div className={styles.texts}>
              <h2 className={styles.title}>
                Notre façon de construire nous définit.
              </h2>
              <p>
                Curieux par nature et avec l&apos;envie de bien faire, nous
                étudions chaque projet du mieux possible afin de vous proposer
                la ou les solutions qui vous correspond(ent).
              </p>
              <div className={styles.btn_container}>
                <MyButton to="/a-propos#teams" label="Notre Équipe" />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.second_row}>
          <div className={styles.contents}>
            <h2>La collaboration est au cœur de notre travail.</h2>
            <div className={styles.texts}>
              <h2 className={styles.title}>
                La collaboration est au cœur de notre travail.
              </h2>
              <p>
                Échanger est essentiel. De la conception à la réalisation, le
                travail et les idées de chacun sont essentiels. Il y en a
                toujours plus dans plusieurs têtes que dans une !
              </p>
              <div className={styles.btn_container}>
                <MyButton to="/jobs" label="Nous rejoindre" />
              </div>
            </div>
            <Image
              src={work}
              alt="La collaboration est au cœur de notre travail."
              className={styles.img}
            />
          </div>
        </div>
        <div className={styles.bg_white_container}>
          <Image src={bgBeige} alt="bg" />
        </div>
      </div>
      <div className={styles.nos_valeurs}>
        <MyH2 className={styles.h2_title}>Nos valeurs</MyH2>
        {nosValeurs.map(({ title, icon, text }) => (
          <div key={uniqid()} className={styles.item}>
            <TitleIcon title={title} img={icon} styles={styles}/>
            <div
              className={styles.paragraph_container}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </div>
        ))}
      </div>
      <div id="teams" />
      <div className={styles.teams}>
        <MyH2 className={styles.title}>Présentation d’équipe</MyH2>
        <p className={styles.text}>
          Une entreprise n&apos;est pas grand chose sans son équipe qui la
          constitue !
        </p>
        <div className={styles.teams_container}>
          {teamMembers.map(
            ({ img, fullName, text, mock }) => (
              <div className={styles.team_item} key={uniqid()}>
                <div className={styles.img_container}>
                  {/* 226x246 */}
                  <Image
                    src={img}
                    className={classNames({ "opacity-0": mock })}
                    width={205}
                    height={208}
                    alt={fullName}
                  />
                </div>
                <div className={styles.infos}>
                  <div className={styles._container}>
                    <h3>{fullName}</h3>
                    <div
                      className={styles.text_container}
                      dangerouslySetInnerHTML={{ __html: text }}
                    />
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </>
  );
};


export default Apropos;